import { useHistory } from "react-router-dom";
import { BsCheck } from "react-icons/all";
import { useColorModeValue } from "@chakra-ui/react";

import { Button, CustomColorScheme } from "components/Button";
import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { useGetThemeColors } from "ChakraTheme";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

interface IProps {
  appointmentId: string | number;
  groupId: string;
  queueId: string;
}

const RedirectToAppointmentButton = ({
  appointmentId,
  groupId,
  queueId,
}: IProps) => {
  const { push } = useHistory();
  const { friendlyUrl } = useGetFriendlyUrl();
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.white, colors.black);
  return (
    <Button
      customColorScheme={CustomColorScheme.Green}
      m="auto"
      minW="200px"
      h="70px"
      leftIcon={<Icon color={iconColor} icon={BsCheck} />}
      onClick={() => {
        push(
          `/e-rezerwacja/${friendlyUrl}/${groupId}/rezerwacja/${queueId}/podsumowanie/${appointmentId}`
        );
      }}
      id="redirect-to-appointment-btn"
    >
      <ChakraText>Kontynuuj</ChakraText>
    </Button>
  );
};

export { RedirectToAppointmentButton };
